import type { Dispatch, AnyAction } from 'redux';

import * as CheckVendorUniqueIdAPI from 'ab-api/web/material/checkVendorUniqueId';
import * as CreateBulkMaterialAPI from 'ab-api/web/material/createBulk';
import * as EditBulkMaterialAPI from 'ab-api/web/material/editBulk';
import * as FindDefaultOnJobAPI from 'ab-api/web/material/findDefaultOnJob';
import * as FindMaterialsForCompanyAPI from 'ab-api/web/material/findForCompany';
import * as FindMaterialsForJobImportAPI from 'ab-api/web/material/findForJobImport';
import * as FindMaterialGroupsAPI from 'ab-api/web/material/findGroups';
import * as RemoveMaterialsBulkAPI from 'ab-api/web/material/removeBulk';
import * as SetDefaultOnJobBulkAPI from 'ab-api/web/material/setDefaultOnJobBulk';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import { MATERIAL_LIST_EDIT } from 'af-constants/reduxForms';

interface FindCompanyMaterials {
	group: Nullable<string>;
	search: string;
	page: number;
}
export function findCompanyMaterials(event: FindCompanyMaterials) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const { group, search, page } = event;
			const url = `${FindMaterialsForCompanyAPI.URL(group ?? '', search, page)}`;
			return await http.get<FindMaterialsForCompanyAPI.W_Material_FindForCompany_VM>(url);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findMaterialGroups() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const url = FindMaterialGroupsAPI.URL();
			return await http.get<FindMaterialGroupsAPI.W_Material_FindGroups_VM>(url);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createMaterialsBulk(event: CreateBulkMaterialAPI.W_Material_CreateBulk_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<CreateBulkMaterialAPI.W_Material_CreateBulk_VM>(CreateBulkMaterialAPI.URL(), event);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function removeMaterialsBulk(event: RemoveMaterialsBulkAPI.W_Material_RemoveBulk_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<void>(RemoveMaterialsBulkAPI.URL(), event);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function editMaterialBulk(data: EditBulkMaterialAPI.W_Material_EditBulk_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(EditBulkMaterialAPI.URL(), data, { submitting: MATERIAL_LIST_EDIT });
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

interface CheckVendorUniqueId {
	vendorId: number;
	uniqueId: string;
}
export function checkVendorUniqueId(event: CheckVendorUniqueId) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const { vendorId, uniqueId } = event;

			return await http.get<CheckVendorUniqueIdAPI.W_Material_CheckVendorUniqueId_VM>(CheckVendorUniqueIdAPI.URL(vendorId, uniqueId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

interface FindMaterialsForJobImport {
	jobId: number;
	group: string;
}
export function findMaterialsForJobImport(event: FindMaterialsForJobImport) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const { jobId, group } = event;
			const url = FindMaterialsForJobImportAPI.URL(jobId, group);
			return await http.get<FindMaterialsForJobImportAPI.W_Material_FindForJobImport_VM>(url);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
export function findDefaultOnJobMaterials() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const url = FindDefaultOnJobAPI.URL();
			return await http.get<FindDefaultOnJobAPI.W_Material_FindDefaultOnJob_VM>(url);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function setDefaultOnJobBulk(data: SetDefaultOnJobBulkAPI.W_Material_SetDefaultOnJobBulk_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(SetDefaultOnJobBulkAPI.URL(), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
